import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
// import { fetchTreeList } from '@/api/system/menu/menu'
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchRoleMenu, fetchCreateRoleMenu } from '@/api/system/role/role';
export default {
  data: function data() {
    return {
      treeData: [],
      checkData: [],
      detialList: [],
      usertype: '',
      defaultProps: {
        children: 'pmsTree',
        label: 'name'
      }
    };
  },
  // props: [ 'showDialog','getTreeData'],
  props: {
    showDialog: Boolean,
    checkedNodes: {
      // 选中的节点
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    // this.usertype = this.$store.state.user.userType
    // this.loadData()
    this.loadMenuTree();
    this.init();
  },
  // mounted() {
  //   this.addDis(this.treeData)
  // },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
        this.treeData = [];
        this.checkData = [];

        if (this.showDialog) {
          // this.loadData()
          this.loadMenuTree();
        }
      }
    }
  },
  methods: {
    // loadMenuTree() {
    //   // const queryJson = {userType: this.usertype}
    //   // fetchTreeList(queryJson).then(response => {
    //   //   this.treeData = response.data.data
    //   // })
    //   const treeQuery = { flag: 8 }
    //   fetchTreeList(treeQuery).then(response => {
    //     this.treeData = response.data.data
    //   })
    // },
    init: function init() {// this.checkData = ['28']
      // this.loadMenuTree()
    },
    loadMenuTree: function loadMenuTree() {
      var _this = this;

      // 加载树
      var treeQuery = {
        flag: 8
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this.checkedId = 0;
        _this.treeData = response.data.data;

        _this.treeFormat(_this.treeData);

        if (_this.checkedNodes.length > 0) _this.$refs.tree.setCheckedKeys(_this.checkedNodes); // if (1) this.$refs.tree.setCheckedKeys([1,2,3])
      });
    },
    treeFormat: function treeFormat(list) {
      var _this2 = this;

      list.forEach(function (item) {
        _this2.treeChildFormat(item);

        if (item.pmsTree && item.pmsTree.length > 0) {
          _this2.treeFormat(item.pmsTree);
        }
      });
    },
    treeChildFormat: function treeChildFormat(child) {
      child.checkedId = ++this.checkedId;
    },
    checkChange: function checkChange() {
      var checkedTreeNodes = this.$refs.tree.getCheckedNodes();
      var addIdList = this.$refs.tree.getCheckedKeys();
      console.log(checkedTreeNodes, addIdList, 'checkedTreeNodes');
      var filterData = checkedTreeNodes.filter(function (item) {
        return item.flag === '211';
      });
      this.detialList = filterData.map(function (item) {
        return item.id;
      });
      console.log(this.detialList, 'this.detialList'); // this.detialList = filterData.map(item => {
      //   return {
      //     resourceId: item.id,
      //     flag: item.flag
      //   }
      // })
    },
    // handCreate() {
    //   const addIdList = this.$refs.tree.getCheckedKeys()
    //   console.log(addIdList,'addIdList');
    //   this.getTreeData(addIdList)
    //   this.$emit('handCancle11', false)
    //   // fetchCreateRoleMenu(this.roleId, addIdList).then(response => {
    //   //   this.$emit('handCancle11', false)
    //   //   this.Alert({ alertType: 'add', message: '角色授权成功' })
    //   // })
    // },
    handCreate: function handCreate() {
      console.log('///0000');

      if (this.detialList && this.detialList.length > 0) {
        // this.$emit('handCancle', true)
        // this.$emit('sendHouseData', this.detialList)
        // this.getTreeData(this.detialList)
        console.log('this.this.detialList', this.detialList);
        this.$emit('getTreeData', this.detialList);
        this.$emit('handCancle11', false);
      } else {
        this.$message.error('请选择需要租赁的房间');
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle11', false);
    }
  }
};